import {
  ApiInsertionType,
  ApiOperator,
  LocationItemLocationItemCondition,
  ApiProductTaggerUniqueField,
  ApiReservedConversion,
} from "@incendium/api";
import { enumToArray } from "Helpers/enumToText";

export const AuthToken = "IncendiumAuthToken";

const location = window.location;
const host = location.host;

/**
 * Get the current selected environment from stored auth tokens
 */
export const getSelectedEnvironment = (): string | null => {
  try {
    const authData = localStorage.getItem(AuthToken);
    if (!authData) return null;
    const parsed = JSON.parse(authData);
    return parsed.selectedEnv || null;
  } catch (e) {
    return null;
  }
};

/**
 * Get the dynamic BaseURL based on the selected environment
 * For localhost: always use localhost:7778
 * For production: use rest.{env}.incendium.ai format
 */
export const getBaseURL = (): string => {
  if (host.includes("localhost")) {
    // return `https://rest.usw.incendium.ai`;
    return "http://localhost:7778";
  }

  const env = getSelectedEnvironment();
  if (env) {
    // Extract base domain from host (e.g., "portal.incendium.ai" -> "incendium.ai")
    const baseDomain = host.split('.').slice(-2).join('.');
    return `${location.protocol}//rest.${env}.${baseDomain}`;
  }

  // Fallback to standard URL if no environment selected
  return `${location.protocol}//rest.${host}`;
};

// Legacy BaseURL export for backwards compatibility
export const BaseURL = getBaseURL();

export const ApiURL = host.includes("localhost")
  ? "http://localhost:9091"
  : `${location.protocol}//api.${host}`;
export const PlatformURL = host.includes("localhost")
  ? "http://localhost:3000"
  : `${location.protocol}//${host}`;
export const MiddleEarthURL = host.includes("localhost")
  ? "http://localhost:8081"
  : `https://me.incendium.ai`;

export const RuleTypes: LocationItemLocationItemCondition[] = enumToArray(
  LocationItemLocationItemCondition
).filter(
  (item) =>
    item !==
    LocationItemLocationItemCondition.LOCATION_ITEM_CONDITION_UNSPECIFIED &&
    item !== LocationItemLocationItemCondition.ANY
);

export const OpertatorTypes: ApiOperator[] = enumToArray(ApiOperator).filter(
  (item) => item !== ApiOperator.OPERATOR_UNASSIGNED
);
export const InsertionTypes: ApiInsertionType[] = enumToArray(
  ApiInsertionType
).filter((item) => item !== ApiInsertionType.IT_UNSPECIFIED);

export const ProductTaggerUniqueFields: ApiProductTaggerUniqueField[] =
  enumToArray(ApiProductTaggerUniqueField);

export const ReservedConversionFields: ApiReservedConversion[] = enumToArray(
  ApiReservedConversion
).filter((i) => i !== ApiReservedConversion.NOT_RESERVED);
